import api from './api';
import { refresh } from './refresh';

export { refresh };

export const login = async (email, password) => {
  const response = await api.post('/api/auth/login', { email, password });
  return response.data;
};

export const register = async (userData) => {
  const response = await api.post('/api/auth/register', userData);
  return response.data;
};

export const logout = async () => {
  const response = await api.post('/api/auth/logout', {});
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get('/api/auth/me');
  return response.data;
};

export const verifyEmail = async (token, uid) => {
  const response = await api.post('/api/auth/verify-email', { token, uid });
  return response.data;
};

export const resendVerification = async (email) => {
  const response = await api.post('/api/auth/resend-verification', { email });
  return response.data;
};

export const requestPasswordReset = async (email) => {
  const response = await api.post('/api/auth/password/reset-request', { email });
  return response.data;
};

export const resetPassword = async (token, password) => {
  const response = await api.post('/api/auth/password/reset', { token, password });
  return response.data;
};

export default api;
